import React from 'react';
import { EmptySlot } from './EmptySlotCard.styles';

const EmptySlotCard: React.FC = () => {
  return <EmptySlot></EmptySlot>;
};

export default EmptySlotCard;
